import classNames from 'classnames';

import styles from './AbsencesFooter.module.scss';

interface Props {
  sticky?: boolean;
  children: React.ReactNode;
}

const AbsencesFooter: React.FC<Props> = ({ children, sticky = false }) => (
  <div className={classNames(styles.wrapper, { [styles.sticky]: sticky })}>
    <div className={styles.inner}>{children}</div>
  </div>
);

export default AbsencesFooter;
